export const state = {
  modalViewTicket: false,
  tickets: [],
  ticket: {}
};

export default {};
